export default [
  {
    path: '/atendimentos-no-mes',
    component: () => import('@/pages/AtendimentosNoMes/Index.vue'),
  },
  {
    path: '/atendimentos-no-mes/profissional',
    component: () => import('@/pages/AtendimentosNoMes/Profissional.vue'),
  },
]
